import { API_FILE_PREFIX } from '@shared/config/api/api-prefixes';
import { FileCreateDataRequest, FileCreateDataResponse } from './create-file-types';
import { fileApi } from '@entities/file/api/file-api';
import { objectToFormData } from '@shared/lib/utils/object-to-form-data/object-to-form-data';

export const fileCreateApi = fileApi.injectEndpoints({
    endpoints: (build) => ({
        fileCreate: build.mutation<FileCreateDataResponse, FileCreateDataRequest>({
            query: (data) => {
                return {
                    url: API_FILE_PREFIX,
                    method: 'POST',
                    body: objectToFormData({ ...data }),
                    headers: {
                        'Content-Type': 'multipart/form-data;',
                    },
                };
            },
            invalidatesTags: ['FilesList'],
        }),
    }),
});

export const { useFileCreateMutation } = fileCreateApi;
